import api from '@/utils/api';

/**
 * Create quote module
 * @param {object} quoteModuleData - The quote module data
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const createCompanyQuoteModuleApi = (quoteModuleData, companyId) =>
  api.post(`/company/${companyId}/quote-module`, quoteModuleData);

export default createCompanyQuoteModuleApi;
